/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum BubblegumEventType {
  Uninitialized,
  LeafSchemaEvent,
}

export type BubblegumEventTypeArgs = BubblegumEventType;

export function getBubblegumEventTypeEncoder(): FixedSizeEncoder<BubblegumEventTypeArgs> {
  return getEnumEncoder(BubblegumEventType);
}

export function getBubblegumEventTypeDecoder(): FixedSizeDecoder<BubblegumEventType> {
  return getEnumDecoder(BubblegumEventType);
}

export function getBubblegumEventTypeCodec(): FixedSizeCodec<
  BubblegumEventTypeArgs,
  BubblegumEventType
> {
  return combineCodec(
    getBubblegumEventTypeEncoder(),
    getBubblegumEventTypeDecoder()
  );
}
